<div class="glass context-holder">
    <ul class="list-group list-group-flush mb-3">
        <li class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-center"
            (click)="newPost()">
            <div class="me-2">Create Post</div>
            <fa-icon [icon]="iconsService.faIconsRegular.faMessage"></fa-icon>
        </li>
        <li class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-center"
            (click)="newMedia()">
            <div class="me-2">Create Media</div>
            <fa-icon [icon]="iconsService.faIconsRegular.faFileVideo"></fa-icon>
        </li>
        <li class="list-group-item pointer list-group-item-action d-flex justify-content-between align-items-center"
            (click)="newMapReaction()">
            <div class="me-2">Map Reaction</div>
            <fa-icon [icon]="iconsService.faIconsRegular.faGrinHearts"></fa-icon>
        </li>
    </ul>
</div>
